import { render } from "./InformationFileItem.vue?vue&type=template&id=89586bce&scoped=true&ts=true"
import script from "./InformationFileItem.vue?vue&type=script&lang=ts"
export * from "./InformationFileItem.vue?vue&type=script&lang=ts"

import "./InformationFileItem.vue?vue&type=style&index=0&id=89586bce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89586bce"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
